import React, { useState, useEffect, useRef } from 'react';
import { Button, Form } from 'react-bootstrap';

import {setaDropdown} from '../../../utils/alternanciaIcones'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'

/*  COMO USAR
    Importe a modal para dentro do componente que irá fazer uso dela.
    ex: import SelectTipoMapa from '../../componentesModais/selects/selectTipoMapa'

    Crie um hook apropriado para esconder e exibir a mensagem quando necessário.
    ex: const [revelarSelectTipoMapa, setRevelarSelectTipoMapa] = useState(false)

    Após isso, posicione-a dentro do return do seu componente e passe os props para
    customizar o conteúdo da mensagem da seguinte forma. É interessante utilizar um
    <Button/> com uma função onClick, dentro de um >Form.Group/> para que o campo
    se mantenha similar aos campos de texto normais.
    ex: <Form.Group>
            <Form.Label>
                <div className="fonte-cor-1 label-campo">TipoMapa {iconeAsterisco}</div>
            </Form.Label>
            { revelarSelectTipoMapa === false &&
                <Button name="cdTipoMapa" className="campo-texto-cor-3 campo-select" onClick={() => setRevelarSelectTipoMapa(!revelarSelectTipoMapa)}>
                    <div className="fonte-cor-1 label-campo">{dsTipoMapa}</div>
                    <img className="campo-select-icone-desativado" src={setaDropdown()} alt="drop" />
                </Button>
            }
            { revelarSelectTipoMapa === true &&
                <SelectTipoMapa
                    setRevelarSelectTipoMapa={setRevelarSelectTipoMapa} //Hook para fechar a modal
                    setCdTipoMapa={setCdTipoMapa} //Código do TipoMapa
                    setDsTipoMapa={setDsTipoMapa} //Nome do TipoMapa
                    dsTipoMapa={dsTipoMapa} 
                    phTipoMapa={phTipoMapa} //Placeholder para mostrar o valor original em caso de edição
                >
                </SelectTipoMapa>
            }
        </Form.Group>*/

export default function SelectTipoMapa(props) {
    const [spinAtivo, setSpinAtivo] = useState(true);
   
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };


    function handleMapa(TipoMapa){
        props.setCdTipoMapa(TipoMapa)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectTipoMapa(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        setSpinAtivo(false)
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectTipoMapa(false)}>
                <div className="fonte-cor-1 label-campo">Alterar tipo de mapa</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    <li>
                        <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleMapa(1)}>
                            <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Status de Conexão</span>
                        </div>
                        <div className="campo-select-divisor-cor-1 campo-select-divisor" />
                    </li>
                    <li>
                        <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleMapa(2)}>
                            <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Distribuição</span>
                        </div>
                        <div className="campo-select-divisor-cor-1 campo-select-divisor" />
                    </li>
                    <li>
                        <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleMapa(3)}>
                            <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Agrupamento</span>
                        </div>
                    </li>
                </ul>
            </div>
        </Form>
    )
}